import { N8N_CONFIG_URL } from "../constants";

export const getConfig = async () => {
  const subdomain = window.location.hostname.split(".")[0];
  const url = new URL(N8N_CONFIG_URL);
  url.searchParams.set("subdomain", subdomain);

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Config fetch failed: ${response.status}`);
  }
  const config = await response.json();
  return config;
};
